import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

import { StudentValueModel } from '../global/components/student_value/model/student_value_model';
import { IInTakeSurveyQuestionMeta } from '../preferences/components/intake_survey/builders/ap_intake_survey_builder';
import { APIntakeSurveyNKHelper } from '../preferences/components/preview_plan/helpers/intake_survey_nk_helper';
import { TermPlanPreviewQuery } from '../preferences/components/preview_plan/queries/preview_term_plan_query';
import { courseDetailState } from './ap_course_details_routes';

const APPreviewPlanCourseDetailsState = {
  ...courseDetailState,
  views: {
    'right-panel-popout@my.planner.preview_plan': {
      template: `<ap-course-details></ap-course-details>`
    }
  }
};

export const ApPreviewPlanRoutes = {
  'my.planner.preview_plan': <ng.ui.IState>{
    url: 'preview_plan/',
    template: `
            <div l-kind="hort" l-no-wrap l-width-fixed>
              <ui-view l-size="grow" l-hug="center"></ui-view>
              <ui-view name="right-panel-popout" class="right-drawer mtl"></ui-view>
              <ui-view name="modal"></ui-view>
            </div>
            `,
    resolve: {
      intakeSurveyPoll: (loadInTakeSurveyPollCommand: ICommand) => loadInTakeSurveyPollCommand(),
      intakeSurveyPollAnswers: (loadInTakeSurveyAnswerCommand: ICommand) => loadInTakeSurveyAnswerCommand(),
      termPreviewAPIParams: (
        intakeSurveyPoll: any,
        intakeSurveyPollAnswers: any,
        ngGetIntakeSurveyQuestionsQuery: IQuery,
        ngAPIntakeSurveyNKHelper: APIntakeSurveyNKHelper
      ) => {
        const questions: IInTakeSurveyQuestionMeta[] = ngGetIntakeSurveyQuestionsQuery.result.questions;
        const termCommitment = _4.find(questions, { nk: ngAPIntakeSurveyNKHelper.intakeSurveyTimeCommitmentNK })._answer
          .nk;
        const termPreference = _4.map(
          _4.find(questions, { nk: ngAPIntakeSurveyNKHelper.intakeSurveyTermPreferenceNK })._answer,
          'nk'
        );
        return {
          termCommitment,
          termPreference
        };
      }
    }
  },
  'my.planner.preview_plan.edit_preference': <ng.ui.IState>{
    url: 'edit_preference/',
    data: {
      pageTitle: 'Edit preference'
    },
    template: '<preview-terms-plan l-kind l-justify="center" questions="$resolve.questions"></preview-terms-plan>',
    resolve: {
      clearTermPreviewPlan: (clearTermPreviewPlanCommand: ICommand) => clearTermPreviewPlanCommand(),
      academicPlan: (loadAcademicPlanCommand: ICommand) => loadAcademicPlanCommand(),
      questions: (termPreviewAPIParams: any, ngGetIntakeSurveyQuestionsQuery: any) =>
        ngGetIntakeSurveyQuestionsQuery.result.questions
    },
    params: {
      source: null
    }
  },
  'my.planner.preview_plan.edit_preference.course_details': { ...APPreviewPlanCourseDetailsState },
  'my.planner.preview_plan.auto_generated': <ng.ui.IState>{
    url: 'auto_generated/',
    template: `<preview-auto-generated-terms 
                l-kind l-justify="center"
                term-commitment="$resolve.termCommitmentAndPreference.termCommitment"
                term-preference="$resolve.termCommitmentAndPreference.termPreference" 
                terms="$resolve.terms">
            </preview-auto-generated-terms>`,
    data: {
      pageTitle: 'Autoloader'
    },
    resolve: {
      academicPlan: (loadAcademicPlanCommand: ICommand) => loadAcademicPlanCommand(),
      previewPlan: (termPreviewAPIParams: any, loadTermPreviewPlanCommand: ICommand) =>
        loadTermPreviewPlanCommand(termPreviewAPIParams.termCommitment, termPreviewAPIParams.termPreference),
      terms: (previewPlan: any, ngTermPlanPreviewQuery: TermPlanPreviewQuery, academicPlan: any) =>
        ngTermPlanPreviewQuery.result.terms,
      termCommitmentAndPreference: (termPreviewAPIParams: any) => termPreviewAPIParams,
      allowToProceed: (
        terms: any,
        $q: ng.IQService,
        completedAutoGeneratedPreviewPlanShowingCommand: ICommand,
        log: any,
        ngStudentValueModel: StudentValueModel,
        ngPreviewTermPlanConstant: ng.IServiceProvider,
        $state: ng.ui.IStateService,
        $timeout: ng.ITimeoutService
      ) => {
        const deferred = $q.defer();
        if (_4.isEmpty(terms)) {
          $timeout(() => {
            log.enable();
            completedAutoGeneratedPreviewPlanShowingCommand().then(() => {
              const currentStudentValue = {};
              ngStudentValueModel
                .keys()
                .forEach((key: string) => (currentStudentValue[key] = ngStudentValueModel.getValueByKey(key)));
              currentStudentValue[ngPreviewTermPlanConstant['AP_PREVIEW_AUTO_GENERATED_TERM_PLAN_SHOWN']] = 'True';
              ngStudentValueModel.update(currentStudentValue);
              deferred.reject();
              $state.go('my.planner.default', {}, { reload: true });
            });
          }, 10);
          log.disable();
        } else {
          deferred.resolve();
        }
        return deferred.promise;
      }
    },
    onErrorState: (
      event: ng.IAngularEvent,
      toState: ng.ui.IStateService,
      toParams: ng.ui.IStateParamsService,
      fromState: ng.ui.IStateService,
      fromParams: ng.ui.IStateParamsService,
      rejection: any
    ) => 'my.planner.preview_plan.auto_generated_error'
  },
  'my.planner.preview_plan.auto_generated.course_details': { ...APPreviewPlanCourseDetailsState },
  'my.planner.preview_plan.auto_generated_error': <ng.ui.IState>{
    url: 'auto_generated_error/',
    data: {
      pageTitle: 'Autoloader error page'
    },
    template: '<preview-plan-auto-generated-failure l-kind l-justify="center"></preview-plan-auto-generated-failure>'
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/ap_preview_plan_routes.ts